import { render, staticRenderFns } from "./FiltersForEditor.vue?vue&type=template&id=331faf4a&scoped=true&"
import script from "./FiltersForEditor.vue?vue&type=script&lang=js&"
export * from "./FiltersForEditor.vue?vue&type=script&lang=js&"
import style0 from "./FiltersForEditor.vue?vue&type=style&index=0&id=331faf4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331faf4a",
  null
  
)

export default component.exports